import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/**
 * ContentTitle:
 *  - Renders the NotebookContent Section ContentTitle
 */
export function ContentTitle(props) {
  const className = `${style.title} ${props.className}`;

  const renderNumber = () =>
    typeof props.number === 'number' ? `${props.number}. ` : null;

  return (
    <div className={className}>
      <h2>
        {renderNumber()}
        {props.title}
      </h2>
    </div>
  );
}

ContentTitle.propTypes = {
  /**
   * Id number for the content Item
   */
  number: PropTypes.number,
  /**
   * ContentTitle to be displayed Content Section
   */
  title: PropTypes.string.isRequired,
  /**
   * ClassName
   */
  className: PropTypes.string,
};

ContentTitle.defaultProps = {
  title: '',
  number: undefined,
  className: '',
};
